import React from 'react'

import { Portlet, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import TiposDeDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'

const portletBreadcrumbs = [{ name: 'Consulta Guias' }]

const tableHeaderRows = [
  {
    label: 'FECHA',
    width: 100,
    align: 'center',
    filter: {
      type: 'date',
      name: 'fecha'
    }
  },
  { label: 'TIPO', width: 190, align: 'center' },
  {
    label: 'SERIE DOC',
    width: 120,
    align: 'center',
    filter: {
      type: 'text',
      name: 'serDoc'
    }
  },
  {
    label: 'NUM. DOC',
    width: 130,
    align: 'center',
    filter: {
      type: 'text',
      name: 'numDoc'
    }
  },
  {
    label: 'RUC',
    width: 130,
    align: 'center',
    filter: {
      type: 'text',
      name: 'ruc'
    }
  },
  {
    label: 'RAZÓN SOCIAL',
    align: 'center',
    filter: {
      type: 'text',
      name: 'razSoc'
    }
  },
  { label: 'OBSERV.', width: 50, align: 'center' },
  { label: '', width: 30, align: 'center' }
]

const ListaComprasPage = ({ history }) => {
  const tablaRef = React.useRef(null)

  const clickVerHandle = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.CONSULTAGUIAS_VER_DETALLES}/${_id}`)
    },
    [history]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Consulta Guias' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Table.ServerSide
            ref={tablaRef}
            useNest={true}
            useFilters={true}
            url='/kardex'
            baseParams={{
              tipoConsulta: 'guias-consulta'
            }}
            headRows={tableHeaderRows}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell align='center'>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell align='center'>
                  {row.tipoDocumento ? TiposDeDocumentoSunatConstant.__dictionary[row.tipoDocumento].nombre : '--'}
                </Table.Cell>
                <Table.Cell align='center'>{row.serieDocumento || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.numeroDocumento || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.documentoSocio || '--'}</Table.Cell>
                <Table.Cell>{row.nombreSocio || '--'}</Table.Cell>
                <Table.Cell>{row.flagAnulado ? 'ANULADO' : '--'}</Table.Cell>
                <Table.Cell align='center'>
                  {row.flagAnulado ? (
                    <>--</>
                  ) : (
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item key='ver' handleClose={handleClose} onClick={() => clickVerHandle({ _id: row._id })}>
                          Ver Detalles
                        </Table.Dropdown.Item>
                      ]}
                    </Table.Dropdown>
                  )}
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default ListaComprasPage
